<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        {{ titreModal }}
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column mt-6 mx-4">
      <AgrialInput
        v-model="titre"
        :rules="[rules.required]"
        label="Titre *"
        hide-details
      />
    </div>
    <div class="d-flex flex-column">
      <div class="d-flex flex-column mt-6 mx-4">
        <v-textarea
          v-model="texte"
          label="Texte*"
          counter="100"
          maxlength="100"
          rows="1"
          auto-grow
          outlined
          :rules="[rules.count, rules.required]"
          placeholder-value="Saisissez votre texte"
        />
      </div>
      <div class="d-flex flex-column mt-6 mx-4">
        <AgrialSelect
          v-model="pagesOriginesSelected"
          :items="pagesOriginesFiltrees"
          item-text="libelle"
          label="Pages origine *"
          return-object
          multiple
          hide-details
        />
      </div>
      <BaseMessage
        v-if="checkSamePagesOrigines"
        class="mx-5 mt-3"
        color="warning"
        message="Attention! Une des pages choisie existe déjà dans un autre rebond."
        text
        type="warning"
      />
      <div class="d-flex flex-column mt-6 mx-4">
        <AgrialSelect
          v-model="pageDestinationSelected"
          :items="pagesWeb"
          item-text="libelle"
          label="Page destination *"
          return-object
          hide-details
        />
      </div>
      <BaseMessage
        v-if="checkSamePageDestination"
        class="mx-5 mt-3"
        color="warning"
        message="Attention! La page choisie est présente dans les pages d'origine."
        text
        type="warning"
      />
      <div class="d-flex flex-column mt-6 mx-4">
        <AgrialSelect
          v-model="cible"
          :items="cibles"
          item-text="libelle"
          item-value="code"
          label="Public visé *"
          hide-details
          return-object
        />
      </div>
      <div class="d-flex flex-column mt-6 mx-4">
        <AgrialDatepicker
          v-model="dateDebut"
          label="Date début *"
          :rules="[rules.required]"
        />
      </div>

      <div class="d-flex flex-column mt-6 mx-4">
        <AgrialDatepicker
          v-model="dateFin"
          label="Date fin"
        />
      </div>
      <BaseMessage
        v-if="isDatesInvalides"
        class="mx-5"
        color="error"
        message="La date de fin ne peut pas être avant la date de début."
        text
        type="error"
      />
      <div class="d-flex flex-column mt-6 mx-4">
        <AgrialCheckbox
          v-model="isNouveaute"
          label="Nouveauté"
          hide-details
        />
      </div>
      <div class="d-flex flex-column mt-6 mx-4">
        <v-select
          v-model="pictogramme"
          :items="pictogrammes"
          label="Pictogramme"
          solo
          hide-details
          clearable
        >
          <template v-slot:selection="{ attrs, item, parent, selected }">
            <div class="picto">
              <v-img
                :src="picto(item.path)"
              />
            </div>
          </template>
          <template v-slot:item="{ index, item }">
            <div class="picto">
              <v-img
                :src="picto(item.path)"
              />
            </div>
          </template>
        </v-select>
      </div>
      <div class="my-4 ml-5 action texte-gris-fonce">
        * Champs obligatoires
      </div>
      <BaseMessage
        v-if="erreur"
        class="mb-4 mx-5"
        color="error"
        :message="erreur"
        text
        type="error"
      />
      <div class="d-flex justify-space-around">
        <AgrButton
          class="pa-5"
          outlined
          @click="onClose()"
        >
          Annuler
        </AgrButton>
        <AgrButton
          :disabled="!isValid"
          :loading="loading"
          class="pa-5"
          @click="saveRedirection()"
        >
          Valider
        </AgrButton>
      </div>
    </div>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import AgrialCheckbox from '@/components/form/agrial-checkbox.vue'
import AgrialDatepicker from '@/components/form/agrial-datepicker.vue'
import AgrialInput from '@/components/form/agrial-input.vue'
import AgrialSelect from '@/components/form/agrial-select.vue'
import { mapActions, mapGetters } from 'vuex'
import BaseMessage from '@/components/common/base-message.vue'
import {clone} from '@/utils/clone'
import { parse, isAfter } from 'date-fns'
import { isEmptyString } from '@/utils/string'
import { difference } from 'lodash'
import { PUBLICS_VISES, PUBLIC_VISE_PAR_DEFAUT } from '@/utils/public-vise'

export default {
  name: 'AjoutRebondModal',
  components: {AgrButton, AgrialCheckbox, AgrialDatepicker, AgrialInput, AgrialSelect, BaseMessage},
  props: {
    redirection: {
      type: Object,
      default: null
    },
    redirections: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      isEmptyString: isEmptyString,
      loading: false,
      erreur: null,
      redirectionModifiable: {},
      isUpdateModalOpen: false,
      titre: null,
      texte: null,
      pagesOriginesSelected: [],
      pageDestinationSelected: null,
      dateDebut: null,
      dateFin: null,
      cible: PUBLIC_VISE_PAR_DEFAUT,
      isNouveaute: false,
      pictogramme: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
        count: value => ((value || '').length <= 100) || 'Nb caractères doit être < 100',
      }
    }
  },

  computed: {
    ...mapGetters({
      pagesWeb: 'redirection/pagesOrigines',
      pictogrammes: 'redirection/pictogrammes'
    }),
    cibles () {
      return PUBLICS_VISES
    },
    titreModal () {
      return this.redirection && this.redirection.id != null ? this.redirection.titre : 'Nouveau rebond'
    },
    isDatesInvalides () {
      return isAfter(parse(this.dateDebut, 'yyyy-MM-dd', new Date()), parse(this.dateFin, 'yyyy-MM-dd', new Date()))
    },
    pagesOriginesFiltrees () {
      return this.pagesWeb.filter(p => p.principale)
    },

    isValid () {
      return this.titre != null
        && this.texte != null
        && this.texte.split('').length <= 100
        && this.pagesOriginesSelected.length > 0
        && this.pageDestinationSelected != null
        && this.dateDebut != null
        && this.cible != null
        && !this.isDatesInvalides
        && !this.isEmptyString(this.titre)
        && !this.isEmptyString(this.texte)
    },
    checkSamePagesOrigines () {
      let redirectionsFiltrees = this.redirection!= null ? JSON.parse(JSON.stringify(this.redirections)).filter(a => a.id!= null && a.id !== this.redirection.id) : JSON.parse(JSON.stringify(this.redirections))
      if (redirectionsFiltrees.length > 0) {
        let pathPagesRebondsExistants = redirectionsFiltrees.map(p => p.pagesOrigines)[0].flatMap(r=>r.pathFront)
        let pathPagesRebondsSelected = this.pagesOriginesSelected.map(p => p.pathFront)
        return pathPagesRebondsExistants.length > difference(pathPagesRebondsExistants, pathPagesRebondsSelected).length
      }
      return false
    },
    checkSamePageDestination () {
      if (this.pagesOriginesSelected.length > 0) {
        return this.pagesOriginesSelected.includes(this.pageDestinationSelected)
      } else {
        return false
      }
    }
  },

  created () {
    this.getPagesOrigines()
    this.getPictogrammes()
    if (this.redirection) {
      this.redirectionModifiable = clone(this.redirection)
      this.titre = this.redirectionModifiable!= null ? this.redirectionModifiable.titre : null
      this.texte = this.redirectionModifiable!= null ? this.redirectionModifiable.texte : null
      this.pagesOriginesSelected = this.redirectionModifiable!= null ? this.redirectionModifiable.pagesOrigines : []
      this.pageDestinationSelected = this.redirectionModifiable!= null ? this.redirectionModifiable.pageDestination : null
      this.dateDebut = this.redirectionModifiable!= null ? this.redirectionModifiable.dateDebut : new Date()
      this.dateFin = this.redirectionModifiable!= null ? this.redirectionModifiable.dateFin : null
      this.cible = this.redirectionModifiable!= null ? this.redirectionModifiable.cible : PUBLIC_VISE_PAR_DEFAUT
      this.isNouveaute = this.redirectionModifiable!= null ? this.redirectionModifiable.nouveaute : false
      this.pictogramme = this.redirectionModifiable!= null ? this.redirectionModifiable.pictogramme : null
    }
  },

  methods: {
    ...mapActions({
      getPagesOrigines: 'redirection/getPagesOrigines',
      getPictogrammes: 'redirection/getPictogrammes',
      createOrUpdateRedirection: 'redirection/createOrUpdateRedirection',
    }),
    saveRedirection () {
      this.loading = true
      this.erreur = null
      this.redirectionModifiable.titre = this.titre
      this.redirectionModifiable.texte = this.texte
      this.redirectionModifiable.pagesOrigines = this.pagesOriginesSelected
      this.redirectionModifiable.pageDestination = this.pageDestinationSelected
      this.redirectionModifiable.dateDebut = this.dateDebut
      this.redirectionModifiable.dateFin = this.dateFin
      this.redirectionModifiable.cible = this.cibles.find(c => c.code === this.cible.code)
      this.redirectionModifiable.nouveaute = this.isNouveaute
      this.redirectionModifiable.pictogramme = this.pictogramme
      this.createOrUpdateRedirection(this.redirectionModifiable)
        .then(() => {
          this.$emit('close')
        })
        .catch(err => {
          this.erreur = err.response.data.message
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClose () {
      this.$emit('close')
    },

    updateConfirm () {
      this.titre = null
      this.texte = null
      this.pagesOriginesSelected = []
      this.pageDestinationSelected = null
      this.dateDebut = new Date()
      this.dateFin = null
      this.cible = PUBLIC_VISE_PAR_DEFAUT
      this.isNouveaute = false
      this.pictogramme = null
      this.isUpdateModalOpen = false
    },
    cancelConfirm () {
      this.isUpdateModalOpen = false
    },
    picto (path) {
      return '/images/pictogrammes/' + path + '.svg'
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
.picto {
  width: 4.5em;
}
</style>
